import PrivateLeagueBasicUpdateRequestBody from "./PrivateLeagueBasicUpdateRequestBody";

export default class PrivateLeagueUpdateModel extends PrivateLeagueBasicUpdateRequestBody {
  public type: string = "PRIVATE";
}
